import { FC } from 'react'
import { MyButton } from '../../../shared/ui/button'
import { MyInput } from '../../../shared/ui/input'
import { Modal } from '../../../shared/ui/modal'
import classes from './trialLessonCreate.module.scss'

interface IProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    title: string;
    placeholder: string;
    value: string;
    setValue: (value: string) => void;
    error: string;
    setError: (error: string) => void;
    isLoading: boolean;
    onCreate: () => void;
}

export const TrialCreateOptionModal: FC<IProps> = ({
    open, setOpen, title, placeholder, value, setValue, error, setError, isLoading, onCreate,
}) => {
    return (
        <Modal open={open} setOpen={setOpen}>
            <section className={classes.optionModal}>
                <h3>{title}</h3>
                <MyInput
                    value={value}
                    setValue={setValue}
                    setError={setError}
                    error={error}
                    placeholder={placeholder}
                />
                <section className={classes.optionModalAction}>
                    <MyButton onClick={onCreate} isLoading={isLoading} error={error}>
                        Создать
                    </MyButton>
                </section>
            </section>
        </Modal>
    )
}
